export class FailedToFetchException extends Error {
	/**
	 * Constructor
	 */
	constructor(message?: string) {
		super(message ?? 'Failed to retrieve data');

		// If we support a stack trace, capture it
		if ('captureStackTrace' in Error) {
			Error.captureStackTrace(this, this.constructor);
		} else {
			console.error(`FailedToFetchException Does not support captureStackTrace()!`);
		}
	}
}
